import { getAbbreviation } from "helpers/common"
import React from "react"

const DefaultAvatar = ({
  avatar_url = null,
  name,
  email,
  style,
  className = "justify-content-center",
}) => {
  return (
    <React.Fragment>
      <div className={`d-flex align-items-center gap-2 ${className}`}>
        <div className="table-user-image">
          {avatar_url ? (
            <img src={avatar_url} alt="" />
          ) : (
            <div
              style={{
                width: "36px",
                height: "36px",
                backgroundColor: "#09518c",
                padding: "3px",
                borderRadius: "50%",
                color: "#fff",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                ...style,
              }}
            >
              {getAbbreviation(name)}
            </div>
          )}
        </div>

        <div className="d-flex align-items-start flex-column">
          <div className="table-user-name" title={name}>
            {name}
          </div>
          <div className="table-user-email">{email}</div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default DefaultAvatar
